const geolocationErrorCodes = {
  'invalid-coordinate-provided': 'coordenada inválida proporcionada',
  'server-error-while-updating-coordinates': 'error del servidor mientras se actualizan las coordenadas',
  'error-while-updating-coordinates': 'error mientras se actualizan las coordenadas',
  'server-error-while-getting-coordinates': 'error del servidor mientras se obtienen las coordenadas',
  'not-coordinates-funded': 'coordenadas no encontradas'
};

export default geolocationErrorCodes;
